/**
 * amaActivites Module
 */
import Vue from 'vue';
import AppConfig from "../../../constants/AppConfig";
import {store} from "../../store";
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";




//States
const state = {
   groupes: {},
   groupe: {},
   searchpatient: [],
   loader: false,
};

//Getters
const getters = {
   groupe: state => state.groupe,

   groupes: state => state.groupes,

   medecins: state => state.medecins,

   getLoader(state){
       return state.loader
   }
};

//Actions
const actions = {

   getGroupe(context, payload) {
       function successCallback(response) {
           context.commit('getGroupeHandler', response.data);
       }

       function errorCallback(error) {
           Vue.swal(
               payload.errorMessages.error,
               '',
               'error'
           );
       }

       const localToken = localStorage.getItem('ms-token');

       makeApiRequest(payload.args, {"method" : "GET", "url" : "/v2/groupes/"+payload.args.uuid}, localToken, successCallback, errorCallback, payload.errorMessages);
   },

   getGroupes(context, payload) {
       function successCallback(response) {

           context.commit('getGroupesHandler', { groupes: response.data });
       }

       function errorCallback(error) {
           Vue.swal(
               payload.errorMessages.error,
               '',
               'error'
           );
       }

       const localToken = localStorage.getItem('ms-token');

       makeApiRequest(payload.args, apiModel.groupes.index, localToken, successCallback, errorCallback, payload.errorMessages);
   },

   searchPatients(context, payload) {
       function successCallback(response) {
           context.commit('searchPatientsHandler', { searchpatient: response.data });
       }

       function errorCallback(error) {
           Vue.swal(
               payload.errorMessages.error,
               '',
               'error'
           );
       }

       const localToken = localStorage.getItem('ms-token');

       makeApiRequest(payload.args, apiModel.groupes.SearchPatient, localToken, successCallback, errorCallback, payload.errorMessages);
   },

   // SearchPatient

   async createGroupe(context, payload) {
       function successCallback(response) {
           router.push({ name: 'groupes' });
           Vue.swal(
               payload.successMessage,
               '',
               'success'
           );

       }

       function errorCallback(error) {
           store.dispatch('record', {errors : error.response.data.error});
           Vue.swal(
               payload.errorMessages.error,
               '',
               'error'
           );
       }

       const localToken = localStorage.getItem('ms-token');
       let url = AppConfig.apiUrl + apiModel.groupes.store.url;

       await Vue.axios.post(url, payload.args,{headers: {'Authorization': `Bearer ${localToken}`}}
       ).then(successCallback)
           .catch(errorCallback);
       // makeApiRequest(payload.args, apiModel.Consultation.General.Create, localToken, successCallback, errorCallback, payload.errorMessages);
   },

   clearUrlUser(context){
       context.commit('getUrlModeratorHandler', "");
       context.commit('getUrlPatientHandler', "");
   },
   // create mettging and join it when user is control doctor
   createMettgingAndJoinAsModerator(context, payload) {
       context.commit('setLoader', true);
       function successCallback(response) {
           context.commit('getUrlModeratorHandler', response.data);
           context.commit('setLoader', false);
       }

       function errorCallback(error) {
           Vue.swal(
               payload.errorMessages.error,
               '',
               'error'
           );
           context.commit('setLoader', false);
       }

       const localToken = localStorage.getItem('ms-token');

       makeApiRequest(payload.args, {"method" : "GET", "url" : `/v2/mettings/create/${payload.args.user_id}`}, localToken, successCallback, errorCallback, payload.errorMessages);
   },

   createMettgingAndJoinAsPatient(context, payload) {
       context.commit('setLoader', true);
       function successCallback(response) {
           context.commit('getUrlPatientHandler', response.data);
           context.commit('setLoader', false);
       }

       function errorCallback(error) {
           Vue.swal(
               payload.errorMessages.error,
               '',
               'error'
           );
           context.commit('setLoader', false);
       }

       const localToken = localStorage.getItem('ms-token');

       makeApiRequest(payload.args, {"method" : "GET", "url" : `/v2/mettings/join/${payload.args.user_id}`}, localToken, successCallback, errorCallback, payload.errorMessages);
   },

   //Update Groupe
   async updateGroupe(context, payload) {
       function successCallback(response) {
           router.push({ name: 'groupes' });
           Vue.swal(
               payload.successMessage,
               '',
               'success'
           );

       }

       function errorCallback(error) {
           store.dispatch('record', {errors : error.response.data.error});
           Vue.swal(
               payload.errorMessages.error,
               '',
               'error'
           );
       }

       const localToken = localStorage.getItem('ms-token');
       let url = AppConfig.apiUrl + `/v2/groupes/${payload.args.uuid}`;
    //    console.log(url);

       await Vue.axios.patch(url, payload.args,{headers: {'Authorization': `Bearer ${localToken}`}}
       ).then(successCallback)
           .catch(errorCallback);
   },

   //Delete Groupe
   async deleteGroupe(context, payload) {
       function successCallback(response) {
           router.push({ name: 'groupes' });
           Vue.swal(
               payload.successMessage,
               '',
               'success'
           );

       }

       function errorCallback(error) {
           Vue.swal(
               payload.errorMessages.error,
               '',
               'error'
           );
       }

       const localToken = localStorage.getItem('ms-token');
    //    let url = AppConfig.apiUrl + `/v2/groupes/${payload.args.uuid}`;


       makeApiRequest(payload.args, {"method" : "DELETE", "url" : `/v2/groupes/${payload.args.uuid}`}, localToken, successCallback, errorCallback, payload.errorMessages);
   },

}

//Mutations
const mutations = {
    getGroupeHandler(state, groupe) {
       // Update groupe state
       state.groupe = groupe;
   },
   getGroupesHandler(state, { groupes }) {
       // Update groupe state
       state.groupes = groupes;
   },
   searchPatientsHandler(state, { searchpatient }) {
       // Update groupe state
       state.searchpatient = searchpatient;
   },

   setLoader(state, loader) {
       state.loader = loader;
   }

}


export default {
   state,
   getters,
   actions,
   mutations
}






